import { ReactElement } from "react";

export const Footer = (): ReactElement => {
    return (
        <div></div>
    );
}